
export const dealershipEndpoints = {
  getVehicleMakes: "/service/vehicle-makes/",
  getVehicleModels: "/service/vehicle-models/",
  postVehicle: "/service/vehicles/",
  deleteVehicle: "/service/vehicle-details/",
  getVehicleDetails: "/service/vehicle-details/",
  putVehicleDetails: "/service/vehicle-details/",
  getVehicles: "/service/vehicles/",
};